"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "uggiate-con-ronago": {
    "043e9f15": [{
      "hkey": "bc8cc8cb",
      "slug": "mulini",
      "name": "Mulini",
      "primary": true,
      "skipSearch": false
    }],
    "4818709f": [{
      "hkey": "69658725",
      "slug": "trevano",
      "name": "Trevano",
      "primary": true,
      "skipSearch": false
    }],
    "ca1a25f6": [{
      "hkey": "576e11d7",
      "slug": "uggiate",
      "name": "Uggiate",
      "primary": true,
      "skipSearch": false
    }],
    "4c63fbd9": [{
      "hkey": "e5248f23",
      "slug": "brughiere",
      "name": "Brughiere",
      "primary": true,
      "skipSearch": false
    }],
    "4a130bd4": [{
      "hkey": "8868b9fc",
      "slug": "ronago",
      "name": "Ronago",
      "primary": true,
      "skipSearch": false
    }],
    "32bb3f17": [{
      "hkey": "62caab1c",
      "slug": "fornace",
      "name": "Fornace",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;